import {inject, Injectable} from '@angular/core';
import {collection, Firestore, getDocs} from 'firebase/firestore';
import {signInAnonymously} from 'firebase/auth';
import {FirebaseInitService} from '../shared/firebase-init.service';
import {Question} from '@models';

@Injectable({
	            providedIn: 'root'
            })
export class QuestionaryService {
	private readonly firebaseInit = inject(FirebaseInitService);
	private readonly firebase: Firestore = this.firebaseInit.firestore;
	private collection = collection(this.firebase, 'questions');

	public async getQuestionary() {
		try {
			return await getDocs(this.collection.withConverter(Question.questionConverter));
		} catch (error) {
			if (!this.firebaseInit.auth.currentUser) {
				await signInAnonymously(this.firebaseInit.auth);
				return getDocs(this.collection.withConverter(Question.questionConverter));
			}
			throw error;
		}
	}
}
